import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  addAdditionalHerbToFormula,
  addItemToSingleHerbList,
  getAllHerbs,
} from "../../actions/formulaAction";
import { ERROR, POPUP_ERROR } from "../../constants/types/alertType";
import { constructDisplayText } from "../../utils/helper";
import AlertWrapper from "../../components/AlertWrapper";
const AddHerbPopup = ({
  closePopup,
  formulaId,
  showUnavailableHerbs,
  role,
}) => {
  const dispatch = useDispatch();
  const allHerbList = useSelector((state) => state.formula.present.allHerbList);
  const [selectedItem, SetSelectedItem] = useState(null);
  const formulas = useSelector((state) => state.formula.present.formulaSection);

  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const messages = useSelector((state) => state.alert.popupMessages);
  const alerts = messages.map((x) => (
    <AlertWrapper
      key={x.id}
      message={x.message}
      variant={x.variant}
      id={x.id}
    />
  ));
  useEffect(() => {
    dispatch(getAllHerbs());
  }, []);
  const optionRenderer = ({ label }, { inputValue }) => {
    const matches = match(label, inputValue);
    const parts = parse(label, matches);
    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}
      </div>
    );
  };
  return (
    <Modal size="lg" show={true} id="prescription-popup">
      <Modal.Body className="add-herb-pop">
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">Additional Herbs</h2>
                  <p className="desc">
                    Choose single herb to add to prescription. (does not include
                    dosages).
                  </p>
                </div>
                <div className="col-md-12">
                  <Select
                    onChange={(e) => SetSelectedItem(e.value)}
                    placeholder="Please Choose An Herb"
                    options={
                      showUnavailableHerbs
                        ? allHerbList?.map((x) => ({
                            value: x.HERB_ID,
                            label:
                              x?.INV_ID_Granular &&
                              parseFloat(x?.Granular_Quantity) > 0.0
                                ? constructDisplayText(
                                    x?.HERB_Display,
                                    x?.HERB_Latin_Name,
                                    x?.HERB_Chinese_Name,
                                    x?.INV_ID_Granular
                                  )
                                : constructDisplayText(
                                    x?.HERB_Display,
                                    x?.HERB_Latin_Name,
                                    x?.HERB_Chinese_Name,
                                    x?.INV_ID_Granular
                                  ) + " (Not Available)",
                            isDisabled:
                              x?.INV_ID_Granular &&
                              parseFloat(x?.Granular_Quantity) > 0.0
                                ? false
                                : true,
                            isNonSearchable:
                              x?.INV_ID_Granular &&
                              parseFloat(x?.Granular_Quantity) > 0.0
                                ? false
                                : true,
                          }))
                        : allHerbList
                            ?.filter(
                              (x) =>
                                x?.INV_ID_Granular &&
                                parseFloat(x?.Granular_Quantity) > 0.0
                            )
                            .map((x) => ({
                              value: x.HERB_ID,
                              label: constructDisplayText(
                                x?.HERB_Display,
                                x?.HERB_Latin_Name,
                                x?.HERB_Chinese_Name,
                                x?.INV_ID_Granular
                              ),
                            }))
                    }
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (styles, { isDisabled, isSelected }) => {
                        return {
                          ...styles,
                          backgroundColor: isDisabled
                            ? "#ff474c"
                            : isSelected
                            ? "#2684ff"
                            : undefined,
                          color: isDisabled
                            ? "white"
                            : isSelected
                            ? "white"
                            : "black",
                        };
                      },
                    }}
                    menuPortalTarget={document.body}
                    menuPlacement={"bottom"}
                    menuShouldScrollIntoView={false}
                    formatOptionLabel={optionRenderer}
                  ></Select>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button
              style={{ marginRight: "45px" }}
              className="btn-orange"
              onClick={() => {
                debugger;
                if (
                  role.val === 4 &&
                  allHerbList?.find((x) => x.HERB_ID == selectedItem)
                    .HERB_Is_Toxic
                ) {
                  dispatch({
                    type: POPUP_ERROR,
                    payload:
                      "Students are not able to prescribe potentially toxic herbs.",
                  });
                  return;
                }
                if (
                  singleHerbList?.some((x) => x.id == selectedItem) ||
                  formulas?.some((formula) =>
                    formula.formulaHerbs?.some(
                      (herb) => herb.id == selectedItem
                    )
                  )
                ) {
                  dispatch({
                    type: ERROR,
                    payload: "Selected Herb is already in the list",
                  });
                } else {
                  formulaId === 0
                    ? dispatch(
                        addItemToSingleHerbList(
                          allHerbList?.find((x) => x.HERB_ID == selectedItem)
                        )
                      )
                    : dispatch(
                        addAdditionalHerbToFormula(
                          formulaId,
                          allHerbList?.find((x) => x.HERB_ID == selectedItem)
                        )
                      );
                }
                closePopup();
              }}
            >
              Add
            </button>
          </div>
          <div className="mt-1 popup-error">{alerts}</div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default AddHerbPopup;
